<template>
  <div class="homework-container">
    <!-- 左侧菜单 -->
    <div class="sidebar">
      <div class="menu-list" style="overflow-y: auto; height: 100%">
        <div v-for="(item, index) in menuList" :key="index" class="menu-item" :class="{ active: currentMenu === index }" @click="selectMenu(index)">
          {{ item.normName }}
        </div>
      </div>
    </div>

    <!-- 右侧内容区 -->
    <div class="main-content">
      <div class="header">
        <span class="class-title" v-if="menuList.length > 0"> {{ menuList[currentMenu].normName }} - 学生列表 </span>
        <div class="select-all">
          <span style="margin-right: 10px">全选</span>
          <el-switch v-model="isAllSelected" active-color="#1890ff"></el-switch>
        </div>
      </div>

      <div class="student-list" style="overflow-y: auto">
        <el-checkbox-group v-model="selectedStudents" @change="checkboxGroupChange">
          <div class="student-grid">
            <div v-for="(student, index) in studentList" :key="student.id" class="student-card">
              <el-checkbox :label="student.id" :name="student.id" class="student-checkbox">
                {{ student.studentName }}
              </el-checkbox>
            </div>
          </div>
        </el-checkbox-group>
      </div>

      <div class="footer">
        <el-button type="primary" size="medium" @click="submitSelection" :disabled="selectedStudents.length === 0"> 提交 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { normList, getStudentList, saveClassSign } from '@/config/ipadComputer/classSetting';

  export default {
    data() {
      return {
        currentMenu: 0,
        menuList: [],
        selectedStudents: [],
        studentList: [],
        normId: null,
      };
    },
    computed: {
      isAllSelected: {
        get() {
          return this.selectedStudents.length === this.studentList.length && this.studentList.length > 0;
        },
        set(isChecked) {
          if (isChecked) {
            this.selectedStudents = this.studentList.map((student) => student.id);
          } else {
            this.selectedStudents = [];
          }
        },
      },
    },
    mounted() {
      this.getMenuList();
      this.getStudent();
    },
    activated() {
      this.getMenuList();
      this.getStudent();
    },
    methods: {
      // 获取左侧菜单
      getMenuList() {
        normList().then((res) => {
          if (res.data.resCode == 200) {
            this.menuList = res.data.data;
            if (this.menuList.length > 0) {
              this.normId = this.menuList[this.currentMenu].id;
            }
          }
        });
      },
      // 获取学生列表
      getStudent() {
        getStudentList().then((res) => {
          if (res.data.resCode == 200) {
            this.studentList = res.data.data;
          }
        });
      },
      // 选择菜单
      selectMenu(index) {
        this.currentMenu = index;
        this.normId = this.menuList[index].id;
        this.selectedStudents = [];
      },
      checkboxGroupChange(value) {
        this.selectedStudents = value;
      },
      submitSelection() {
        this.$confirm(`确定要提交${this.selectedStudents.length}名学生的${this.menuList[this.currentMenu].normName}吗？`, '提交确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            // 获取未选择的学生ID数组
            const notChooseStudentIdList = this.studentList
              .filter((student) => !this.selectedStudents.includes(student.id))
              .map((student) => student.id);

            const data = {
              normId: this.normId,
              chooseStudentIdList: this.selectedStudents,
              notChooseStudentIdList: notChooseStudentIdList,
            };
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in data) {
              if (data[key] !== null && data[key] !== undefined) {
                formData.append(key, data[key]);
              }
            }
            saveClassSign(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.selectedStudents = [];
                this.$message({
                  message: '提交成功',
                  type: 'success',
                });
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          })
          .catch(() => {
            // 取消操作，不做处理
          });
      },
    },
  };
</script>

<style scoped>
  .homework-container {
    display: flex;
    flex-direction: row;
    height: calc(100vh - 100px);
    overflow: hidden;
  }

  .sidebar {
    width: 200px;
    background-color: #f5f5f5;
    border-right: 1px solid #e0e0e0;
    height: 100%;
  }

  .menu-item {
    padding: 15px 20px;
    border-bottom: 1px solid #e0e0e0;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .menu-item:hover {
    background-color: #e0e0e0;
  }

  .menu-item.active {
    background-color: #1890ff;
    color: white;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    height: 100%;
    box-sizing: border-box;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
  }

  .class-title {
    font-size: 20px;
    font-weight: bold;
  }

  .select-all {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .student-list {
    flex: 1;
    min-height: 300px;
    background-color: #fafafa;
    border-radius: 12px;
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .student-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
    width: 100%;
  }

  .student-card {
    background: white;
    border-radius: 10px;
    padding: 15px 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
    border: 1px solid #f0f0f0;
    width: 100%;
    box-sizing: border-box;
  }

  .student-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #1890ff;
  }

  .student-checkbox {
    width: 100%;
  }

  .footer {
    margin-top: auto;
    padding-top: 15px;
    border-top: 1px solid #e0e0e0;
    text-align: right;
  }
</style>
